export const COMPANY = {
  name: 'Ehimo Building & Civil Engineering Ltd.',
  shortName: 'EhimoBCE',
  tagline: 'Building & Civil Engineering Construction',
  intro:
    'Ehimo Building & Civil Engineering Ltd (EhimoBCE) is a dynamic building and civil engineering construction company set up to provide world class construction projects to corporate organizations and individual clients.',
  reach:
    'We undertake residential, commercial and industrial engineering construction projects in different geopolitical zones of the country.',
  leadership:
    'EhimoBCE has a team led by a foremost builder, registered with the Council of Registered Builders of Nigeria (CORBON) and a Fellow of the Nigerian Institute of Building (NIOB) — Bldr. Lynus Aiteobhor, FNIOB.',
  vision:
    'To be a role model in the Construction industry in Nigeria by offering exceptional services to our clients through the use of modern construction management skills and tools, and developing leaders through long term investment in human capacity.',
  mission:
    'To continuously channel our energy towards delivering quality and world class building construction projects to our clients and stakeholders.',
  address: '5/7 Alhaja Kofoworola Street, Balogun Bus Stop, Awolowo Way, Ikeja, Lagos, Nigeria',
  hours: 'Mon – Fri: 8:00 – 16:00',
  phones: ['+234 705 565 2985', '+234 817 490 9454'],
  phoneHrefs: ['tel:+2347055652985', 'tel:+2348174909454'],
  email: 'talk@ehimobce.com',
};

export const REPUTATION = [
  'To deliver the project within agreed budget',
  'To deliver the project within agreed schedule',
  'To deliver the project within agreed quality standard',
  'To deliver the project within expected H&S requirement',
  'To offer accountability, openness and honesty',
  'To offer extreme satisfaction in our project delivery',
];

export const TEAM = [
  {
    name: 'Bldr. Aiteobhor Lynus',
    role: 'HND (Building Technology), M.Sc. (Construction Management), FNIOB',
    experience: 'Over 20 years experience',
  },
  {
    name: 'Seyi Osigbesan (Arc)',
    role: 'HND (Architecture)',
    experience: 'Over 10 years experience',
  },
  {
    name: 'Eng. Henry Odutan',
    role: 'B.Sc. (Civil Engineering)',
    experience: 'Over 10 years experience',
  },
];

export const SERVICES = [
  {
    id: 'building-construction',
    number: '01',
    title: 'Building Construction',
    summary: 'We provide our clients with the resources to turn their vision into reality.',
    detail:
      'From residential developments to commercial and industrial facilities, we provide our clients with the resources to turn their vision into reality — executing building projects across different geopolitical zones of Nigeria.',
    covers: ['Residential developments', 'Commercial buildings', 'Industrial facilities'],
    image: '/images/service-building.jpg',
  },
  {
    id: 'design-build',
    number: '02',
    title: 'Design & Build',
    summary: 'Complete construction solutions at each stage of the project.',
    detail:
      'We provide complete construction solutions by involving ourselves in each stage of the project — a single point of responsibility from concept and design through to construction and handover.',
    covers: ['Concept & design coordination', 'Single-point responsibility', 'Construction to handover'],
    image: '/images/service-design.jpg',
  },
  {
    id: 'civil-engineering',
    number: '03',
    title: 'Civil Engineering',
    summary: 'A wealth of knowledge in the execution of road projects, drainages and dams.',
    detail:
      'We offer our wealth of knowledge in the execution of road projects, drainages and dams — delivering the civil works that communities and industry depend on.',
    covers: ['Road projects', 'Drainage systems', 'Dams & water retaining structures', 'Pile foundation'],
    image: '/images/service-civil.jpg',
  },
];

export const PROJECTS = [
  {
    slug: 'lekki-lagos',
    name: 'Lekki, Lagos Project',
    location: 'Lekki, Lagos',
    type: 'Building Construction',
    status: 'On-Going',
    image: '/images/projects/lekki-lagos.jpg',
  },
  {
    slug: 'lagos-island',
    name: 'Lagos Island, Lagos Project',
    location: 'Lagos Island, Lagos',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/lagos-island.jpg',
  },
  {
    slug: 'ilorin',
    name: 'Ilorin Project',
    location: 'Ilorin',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/ilorin.jpg',
  },
  {
    slug: 'uyo-akwa-ibom',
    name: 'Uyo Project',
    location: 'Uyo, Akwa Ibom',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/uyo.jpg',
    gallery: [
      '/images/projects/uyo-1.jpg',
      '/images/projects/uyo-3.jpg',
      '/images/projects/uyo-6.jpg',
      '/images/projects/uyo-7.jpg',
      '/images/projects/uyo-8.jpg',
      '/images/projects/uyo-9.jpg',
    ],
  },
  {
    slug: 'obanikoro-ilupeju',
    name: 'Obanikoro, Ilupeju Project',
    location: 'Obanikoro / Ilupeju, Lagos',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/obanikoro.jpg',
    gallery: ['/images/projects/obanikoro-3.jpg', '/images/projects/obanikoro-4.jpg'],
  },
  {
    slug: 'nim-renovation',
    name: 'Nigerian Institute of Management — Renovation',
    location: 'Lagos',
    type: 'Building Construction',
    status: 'Completed',
    client: 'Nigerian Institute of Management',
    image: '/images/projects/nim.jpg',
    gallery: [
      '/images/projects/nim-1.jpg',
      '/images/projects/nim-2.jpg',
      '/images/projects/nim-3.jpg',
      '/images/projects/nim-4.jpg',
      '/images/projects/nim-5.jpg',
      '/images/projects/nim-6.jpg',
      '/images/projects/nim-7.jpg',
      '/images/projects/nim-8.jpg',
    ],
  },
  {
    slug: 'gra-ikeja',
    name: 'GRA, Ikeja Project',
    location: 'GRA, Ikeja, Lagos',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/gra-ikeja.jpg',
    gallery: ['/images/projects/gra-ikeja-2.jpg'],
  },
  {
    slug: 'ado-ekiti',
    name: 'Ado Ekiti Project',
    location: 'Ado-Ekiti',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/ado-ekiti.jpg',
  },
  {
    slug: 'aker-solutions',
    name: 'Aker Solution Project',
    location: 'Lagos',
    type: 'Building Construction',
    status: 'Completed',
    client: 'Aker Solutions',
    image: '/images/projects/aker.jpg',
  },
  {
    slug: 'abule-egba',
    name: 'Abule Egba Project',
    location: 'Abule Egba, Lagos',
    type: 'Building Construction',
    status: 'Completed',
    image: '/images/projects/abule-egba.jpg',
  },
  {
    slug: 'ikorodu',
    name: 'Ikorodu Project',
    location: 'Ikorodu, Lagos',
    type: 'Building Construction',
    status: 'On-Going',
    image: '/images/projects/ikorodu.jpg',
    gallery: [
      '/images/projects/ikorodu-1.jpg',
      '/images/projects/ikorodu-2.jpg',
      '/images/projects/ikorodu-3.jpg',
      '/images/projects/ikorodu-4.jpg',
      '/images/projects/ikorodu-5.jpg',
      '/images/projects/ikorodu-6.jpg',
      '/images/projects/ikorodu-7.jpg',
      '/images/projects/ikorodu-8.jpg',
    ],
  },
];

export const CLIENTS = [
  { name: 'Nigerian Institute of Management', logo: '/images/clients/nim.png' },
  { name: 'Jason', logo: '/images/clients/jason.png' },
  { name: 'Sterling Assurance', logo: '/images/clients/sterling.png' },
  { name: 'Consolidated', logo: '/images/clients/consolidated.png' },
  { name: 'Aker Solutions', logo: '/images/clients/aker.png' },
];

export const IMAGES = {
  hero: '/images/projects/lekki-lagos.jpg',
  intro: '/images/service-building.jpg',
  safety: '/images/safety.jpg',
  about: '/images/about.jpg',
  worker: '/images/worker.jpg',
};

export const LOGO = '/images/logo.png';

export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Projects', to: '/projects' },
  { label: 'Policies', to: '/policies' },
  { label: 'Contact', to: '/contact' },
];
